import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/wx-users";

export default createStore({ Model });
